import {
  ApplicationRef,
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  input,
  viewChild,
} from '@angular/core';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { Observable, ReplaySubject, Subject, map, mergeMap, take, takeUntil } from 'rxjs';

import { whenTruthy } from 'ish-core/utils/operators';

import { DotCmsFacade } from '../../../facades/dot-cms.facade';
import { CustomDotCmsContentletHelper } from '../../../models/contentlet/custom-dot-cms-contentlet.helper';
import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from '../../../models/dot-cms-content-types-component.model';
import { sliceContents } from '../../../utils/dot-cms-utils';

@Component({
  selector: 'custom-dot-cms-carousel',
  templateUrl: './dot-cms-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsCarouselComponent implements DotCmsContentTypeComponent, OnInit, OnChanges, OnDestroy {
  readonly identifier = input<string>(undefined);
  contentlet$: Observable<CustomDotCmsContentlet>;
  contentlet: CustomDotCmsContentlet;
  slideItems: number;
  posIni: number;
  readonly carousel = viewChild<NgbCarousel>('ngbCarousel');

  carouselContents: CustomDotCmsContentlet[];
  private destroy$ = new Subject<void>();
  itemGridSize = 12;
  contentTypes: string[] = ['banners', 'images', 'videos', 'productsTooltip'];
  identifier$ = new ReplaySubject<string>(1);
  constructor(private appRef: ApplicationRef, private dotCmsFacade: DotCmsFacade) {}

  ngOnInit() {
    this.identifier$
      .pipe(
        whenTruthy(),
        mergeMap(identifier => this.dotCmsFacade.getContentletByIdentifier$(identifier)),
        takeUntil(this.destroy$)
      )
      .subscribe(contentlet => {
        this.contentlet = contentlet;
        this.carouselContents = CustomDotCmsContentletHelper.getSortedSubContentlets(
          contentlet,
          this.contentTypes,
          'sortOrder'
        );
        //No.of.Items Logic
        this.carouselContents = sliceContents(this.contentlet.slideItems, this.carouselContents);
      });
  }

  ngOnChanges(): void {
    this.identifier$.next(this.identifier());
    //Loop Logic
    this.appRef?.isStable
      .pipe(
        whenTruthy(),
        map(() => (this.contentlet?.startCycling ? this.contentlet?.slideInterval : 0)),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe(val => {
        const carousel = this.carousel();
        if (val && val !== 0 && carousel) {
          carousel.interval = val;
          carousel.cycle();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  cssClasses(contentlet: CustomDotCmsContentlet): string {
    if (contentlet?.maxWidth) {
      return 'default-carousel-class full-width-carousel';
    }
    return 'default-carousel-class';
  }
  moveSlider(pos: number) {
    const offset = this.posIni - pos;
    if (offset < -100) {
      this.carousel().prev();
    }

    if (offset > 100) {
      this.carousel().next();
    }
  }
}
